import { render, staticRenderFns } from "./check-request.vue?vue&type=template&id=b4fc903e&scoped=true"
import script from "./check-request.vue?vue&type=script&lang=js"
export * from "./check-request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fc903e",
  null
  
)

export default component.exports